import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { getLineLoginUrl } from './utils/LineLoginActions';

const CustomerRelaxRgister = () => {
  const { stationId } = useParams();

  useEffect(() => {
    if (!stationId) return;

    const getLineLogin = async () => {
      try {
        const result = await getLineLoginUrl('customer_relax', {
          station_id: stationId,
        });
        if (!result.success) {
          throw new Error(result.message);
        }

        window.location.href = result.data.redirect_url;
      } catch (err) {
        console.error(err);
        alert(`error occurred while getting line login: ${err.message}`);
      }
    };

    getLineLogin();
  }, [stationId]);

  return (
    <div>
      <h1>Customer Relax Register</h1>
      <p>Redirecting...</p>
    </div>
  );
};

export default CustomerRelaxRgister;
